export const updateMetaTags = (title, description, image = 'https://haandvaerkernet.dk/images/logo.png', type = 'website') => {
    // Clear existing meta tags first
    const oldMetaTags = document.querySelectorAll('meta[property^="og:"]');
    oldMetaTags.forEach(tag => tag.remove());

    // Update title and meta tags
    document.title = title;

    // Create or update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    // Add new OG tags
    const metaTags = {
        'og:title': title,
        'og:description': description,
        'og:image': image,
        'og:type': type
    };

    Object.entries(metaTags).forEach(([property, content]) => {
        const metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        metaTag.setAttribute('content', content);
        document.head.appendChild(metaTag);
    });
};